import React, { useEffect, useState } from "react";
import DashboardCard from "../../Components/Card/DashboardCard";
import { useSelector } from "react-redux";
import { CircularProgress, Grid } from "@mui/material";
import configServ from "../../services/config";
// icons
import PeopleIcon from "@mui/icons-material/People";
import MedicationIcon from '@mui/icons-material/Medication';
import QuizIcon from '@mui/icons-material/Quiz';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useNavigate } from "react-router-dom";
import CheckAndReturn from "../../utility/CheckAndReturn";
import BarGraph from "./BarGraph";
import VoiceCommand from "../../Components/VoiceRecognization/VoiceCommand ";
import InvoiceLineGraph from "../../Components/Graph/InvoiceLineGraph";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

//FUNCTION
function Dashboard() {
  //#region code
  const { user_id, company_id } = useSelector((state) => state.GlobalVariables);
  const navigate = useNavigate();

  const [count, setCount] = useState({});

  const fetchDashboardCount = async () => {
    try {
      const userId = user_id;
      if (userId === null) {
        navigate("/");
      }
      const dataToSend = {
        user_id: user_id,
        company_id: company_id,
      };
      const result = await configServ.getDashboardCount(dataToSend);
      setCount(result);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDashboardCount();
  }, []);

  const cardData = [
    {
      title: "CUSTOMERS ENQUIRIES",
      number: count.customers ?? <CircularProgress />,
      icon: <PeopleIcon sx={{ color: "#fb6340" }} />,
      link: "/enquiry",
    },
    {
      title: "PAIN AREAS",
      number: count.pain_areas ?? <CircularProgress />,
      icon: <MedicationIcon sx={{ color: "#fb6340" }} />,
      link: "/master-entry/item",
    },
    {
      title: "QUESTIONNAIRES",
      number: count.questionnaires ?? <CircularProgress />,
      icon: <QuizIcon sx={{ color: "#fb6340" }} />,
      link: "/master-entry/questionnaires"
    },
    {
      title: "SOLUTIONS",
      number: count.solutions ?? <CircularProgress />,
      icon: <EmojiObjectsIcon sx={{ color: "#fb6340" }} />,
      link: "/master-entry/solution"
    },
    {
      title: "PRESCRIPTIONS",
      number: count.prescriptions ?? <CircularProgress />,
      icon: <EditNoteIcon sx={{ color: "#fb6340" }} />,
      link: "/prescriptions",
    },
    {
      title: "TOTAL SALES",
      number: count.total_invoice_amount ?? <CircularProgress />,
      icon: <CurrencyRupeeIcon sx={{ color: "#fb6340" }} />,
      link: "/invoice",
    },
    // {
    //   title: "OUTSTANDING",
    //   number: count.outstanding ?? <CircularProgress />,
    //   icon: <CurrencyRupeeIcon sx={{ color: "#fb6340" }} />,
    //   link: "/invoice",
    // },
  ];
  //#endregion

  return (
    <>
      <Grid
        container
        alignItems={"center"}
        justifyContent={"flex-start"}
        spacing={2}
        p={2}
        my={1}
        sx={{
          backgroundColor: "#6270e4",
          width: "100%",
        }}
      >
        {cardData.map((item, index) => (
          <DashboardCard index={index} data={item} />
        ))}
      </Grid>
      <InvoiceLineGraph/>
    </>
  );
}

export default Dashboard;
